import { useRoutes } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { MatxSuspense, MatxTheme } from "./components";
import SettingsProvider from "./contexts/SettingsContext";
import routes from "./routes";
import { registerLicense } from '@syncfusion/ej2-base';
import React, { Suspense } from "react";

registerLicense('ORg4AjUWIQA/Gnt2U1hhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5Rd01jXH9Wc3BWRWBY');

export default function App() {
  const content = useRoutes(routes);
  const authMethod = process.env.REACT_APP_AUTH_METHOD || 'firebase';

  // Dynamically load the provider
  let AuthProvider;

  switch (authMethod) {
    case "AUTH0":
      AuthProvider = React.lazy(() => import("./contexts/Auth0Context").then(module => ({ default: module.AuthProvider })));
      break;
    case "FIREBASE":
      AuthProvider = React.lazy(() => import("./contexts/FirebaseAuthContext").then(module => ({ default: module.AuthProvider })));
      break;
    case "JWT":
      AuthProvider = React.lazy(() => import("./contexts/JWTAuthContext").then(module => ({ default: module.AuthProvider })));
      break;
    default:
      AuthProvider = React.lazy(() => import("./contexts/FirebaseAuthContext").then(module => ({ default: module.AuthProvider })));
  }

  return (
    <SettingsProvider>
      <MatxSuspense fallback={<div>Loading...</div>}>
        <AuthProvider>
          <MatxTheme>
            <CssBaseline />
            {content}
          </MatxTheme>
        </AuthProvider>
      </MatxSuspense>
    </SettingsProvider>
  );
}